export const ELO_TRAVEL = {
  Header: 'TERMOS E CONDIÇÕES DA CAMPANHA ELO+RAPPI TRAVEL',
  Body: [
    {
      Title: null,
      Paragraphs: [
        `Por meio desta oferta, divulgamos os Termos e Condições da campanha
        <strong>"ELO+RAPPI TRAVEL" </strong>por meio da qual os usuários que comprarem
        produtos (aéreo, hotel e/ou autos) na vertical "<em>Travel</em>",
        <strong> com valor acima de R$ 500,00 (quinhentos reais), pagando com cartão ELO, </strong>
        e que utilizarem cupom específico, ganharão um <strong>desconto de R$100,00 (cem reais),</strong>
        em período específico.`,
        '"Usuário" para fins deste T&amp;C significa a pessoa humana inscrita na plataforma Rappi.',
      ],
    },
    {
      Title: 'REGRAS PRINCIPAIS DA PROMOÇÃO:',
      Paragraphs: [
        `<ul>
          <li>
            Esta campanha aplica-se aos usuários da plataforma que realizarem seus
            pedidos utilizando o cupom de desconto no período de
            <strong>22 de junho de 2021 às 00:01 até 15 de agosto de 2021 às 23:59</strong>
          </li>
        </ul>`,
        `<ul>
          <li>
            Esclarece-se que a Campanha aplica-se aos usuários que efetuarem compras
            de produtos (aéreo, hotel e/ou autos) na vertical "<em>Travel</em>",
            <strong>pagando com cartão ELO;</strong>
          </li>
        </ul>`,
        `<ul>
            <li>
              Esclarece-se que o desconto desta promoção será de
              <strong>até R$100,00 (cem reais)</strong>;
            </li>
        </ul>`,
        `<ul>
            <li>
              O valor mínimo da compra para que o cupom possa ser aplicado é de
              <strong>R$ 500,00 (quinhentos reais);</strong>
            </li>
        </ul>`,
        `<ul>
            <li>
              Esclarece-se que esta promoção poderá ser usada
              <strong>uma única vez por Usuário/CPF</strong>;
            </li>
        </ul>`,
        `<ul>
            <li>
              Campanha válida somente para pedidos realizados e pagos através do meio de
              pagamento:<em> ELO;</em>
            </li>
        </ul>`,
        `<ul>
            <li>
              Promoção válida nas áreas de cobertura do aplicativo em todo território
              brasileiro - Brasil;
            </li>
        </ul>`,
        `<ul>
            <li>
              Esclarece-se que a campanha pode ser alterada ou cancelada sem aviso prévio;
            </li>
        </ul>`,
        `<ul>
            <li>
              Reservamo-nos o direito de cancelar qualquer transação que, devido às suas
              características, viole as condições estabelecidas para acessar esta
              promoção;
            </li>
        </ul>`,
        `<ul>
            <li>
              É esclarecido que esta campanha não se aplica a pedidos parcialmente ou
              totalmente cancelados;
            </li>
        </ul>`,
        `<ul>
            <li>
              Esclarece-se que a disponibilidade e categoria das acomodações são de
              responsabilidade do hotel parceiro;
            </li>
        </ul>`,
        `<ul>
            <li>
              Os cupons são únicos e individuais;
            </li>
        </ul>`,
        `<ul>
            <li>
              Promoção não cumulativa e válida até esgotar a quantidade de cupons
              disponíveis.
            </li>
        </ul>`,
      ],
    },
    {
      Title: 'CONDIÇÕES GERAIS DA PROMOÇÃO:',
      Paragraphs: [
        `Promoção válida até a data e hora estipuladas. A Rappi se reserva o direito de
        cancelar qualquer transação que, devido às suas características, viole as
        condições de elegibilidade a esta promoção.`,
        `O usuário reconhece e aceita que o fornecedor direto dos produtos é o Parceiro
        Comercial (estabelecimento comercial), uma vez que este é o único que exibe,
        oferece, promove e comercializa produtos para os usuários/consumidores através
        da Plataforma.`,
        `O Usuário reconhece e aceita que as informações fornecidas e registradas na
        plataforma virtual Rappi são verdadeiras e confiáveis, assumindo total
        responsabilidade por sua falsidade. As informações fornecidas terão o caráter
        de uma declaração juramentada, os Usuários têm total responsabilidade pela
        autenticidade e veracidade da mesma, não sendo a Rappi responsável, caso o
        Usuário incorra na omissão e/ou erro no momento do carregamento dos dados
        solicitados pelo Usuário para obter os benefícios da Promoção.`,
        `O Rappi se reserva o direito de cancelar a promoção, cancelar o código e
        bloqueando a conta do Usuário a qualquer momento, se for determinado que estão
        ocorrendo fraude ou ação ilícita para obtenção do benefício.`,
        `O Rappi se reserva o direito de modificar as condições ou cancelar esta
        promoção a qualquer momento e a seu critério livre.`,
        `O Rappi não permitirá que o Usuário acesse a promoção quando for verificado
        que as contas referidas são fictícias ou falsas. Usuários que realmente não
        constituem uma pessoa física identificável por meio de um documento de
        identidade emitido pela autoridade competente.`,
        `O Rappi reserva-se o direito, a seu exclusivo critério, de modificar, alterar
        ou atualizar estes Termos e Condições a qualquer momento. As modificações
        serão comunicadas no aplicativo RAPPI e entrarão em vigor imediatamente a
        partir do momento de sua publicação.`,
        `O Rappi não comercializa produtos, pois é apenas uma plataforma tecnológica de
        intermediação entre terceiros que exibe serviços e produtos aos
        usuários/consumidores que os adquirem.`,
        `Promoção válida para todos os pedidos que atendem às condições estabelecidas
        nestes Termos e Condições.`,
        `Consulte nossos
          <a href="https://legal.rappi.com/brazil/termos-e-condicoes-de-uso-da-plataforma-rappi/">
            <span>
              Termos de Uso e Condições da Plataforma Rappi
            </span>
          </a>
        e
          <a href="https://legal.rappi.com/brazil/aviso-de-privacidade-e-politicas-de-uso-das-informacao-utilizadas-pela-rappi/">
            <span>
              Aviso de Privacidade de Dados.
            </span>
          </a>`,
        'São Paulo/SP.',
      ],
    },
  ],
};
